import React from 'react';

export type ButtonCardInterface = {
  btnname: string | number;
  text: string;
  onClick?: () => void;
};

export const ButtonCard: React.FC<ButtonCardInterface> = ({ btnname, onClick, text }) => {
  return (
    <button className={`btn-card ${btnname}`} onClick={onClick} type="button">
      <span className="btn-icon"></span>
      <span className="btn-label">{text}</span>
    </button>
  );
};
